import React, { useEffect, useState } from 'react';

import { Modal } from '@cfa/react-core';

import { cn } from '@/utils/tailwind';

export interface ScrollModalProps {
  children: React.ReactNode;
  scrollRef: React.RefObject<HTMLElement | null>;
  showCloseButton?: boolean;
  style?: React.CSSProperties;
}

const ScrollModalFooter: React.FC<ScrollModalProps> = ({
  scrollRef,
  children,
  ...props
}) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const updateScrollStatus = () => {
      const scrollBottom =
        (scrollRef.current?.scrollHeight ?? 0) -
        (scrollRef.current?.clientHeight ?? 0) -
        (scrollRef.current?.scrollTop ?? 0);
      if (scrollBottom > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    scrollRef.current?.addEventListener('scroll', updateScrollStatus);

    return () => window.removeEventListener('scroll', updateScrollStatus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollRef.current]);

  return (
    <Modal.Footer
      {...props}
      className={cn('z-5! p-8!', isScrolled && 'shadow-elevation-16!')}
    >
      {children}
    </Modal.Footer>
  );
};

export default ScrollModalFooter;
